import React from 'react';
import styles from './index.css';
import PropTypes from 'prop-types';
import ShortVideo from './shortVideo';
import ShortPic from './shortPic';

class Short extends React.PureComponent {
    static propTypes = {
        item: PropTypes.object,
    };

    ref = React.createRef();
    componentDidMount() {
        const {
            index,
            item,
            item: { type },
            observer,
        } = this.props;
        this.ref.current.setAttribute('data-index', index);

        observer.observe(this.ref.current);
    }

    render() {
        let { item } = this.props;

        return (
            item &&
            <div ref={this.ref}>
                {(item.videoPlayUrl ? (
                    <ShortVideo content={item} />
                ) : (
                    <ShortPic content={item} />
                ))}
            </div>
        );
    }
}

export default Short;
